/* ============================================================
   Vista rápida (Quick-View) — runtime
   Abre un modal con la carta grande + datos YGO desde los data-* del botón.
   ============================================================ */
(function () {
  'use strict';

  // Varias secciones incluyen este script (carruseles, catálogo, relacionados):
  // sin guard, los listeners de documento se duplicarían (p. ej. doble add-to-cart)
  if (window.__tcgQvInit) return;
  window.__tcgQvInit = true;

  var modal = document.getElementById('tcg-qv');
  if (!modal) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;

  var el = {
    card:    modal.querySelector('[data-qv-card]'),
    front:   modal.querySelector('.tcg-qv__front'),
    flip:    modal.querySelector('[data-qv-flipinner]'),
    img:     modal.querySelector('[data-qv-img]'),
    holo:    modal.querySelector('.tcg-holo'),
    badge:   modal.querySelector('[data-qv-badge]'),
    set:     modal.querySelector('[data-qv-set]'),
    title:   modal.querySelector('[data-qv-title]'),
    price:   modal.querySelector('[data-qv-price]'),
    compare: modal.querySelector('[data-qv-compare]'),
    stats:   modal.querySelector('[data-qv-stats]'),
    desc:    modal.querySelector('[data-qv-desc]'),
    add:     modal.querySelector('[data-qv-add]'),
    full:    modal.querySelector('[data-qv-full]')
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stat(label, value, wide) {
    if (!value) return '';
    return '<li class="' + (wide ? 'tcg-qv-stat--wide' : '') + '"><b>' + label + '</b>' + esc(value) + '</li>';
  }

  function renderStats(s) {
    var rows = '';
    if (s.atk) rows += stat('ATK', s.atk);
    if (s.def) rows += stat('DEF', s.def);
    if (s.attr) rows += '<li class="tcg-attr--' + esc(String(s.attr).toLowerCase()) + '"><b>Atributo</b>' + esc(s.attr) + '</li>';
    if (s.level) rows += stat('Nivel/Rango', '★ ' + s.level);
    if (s.race) rows += stat('Raza', s.race);
    if (s.type) rows += stat('Tipo', s.type);
    if (s.archetype) rows += stat('Arquetipo', s.archetype, true);
    el.stats.innerHTML = rows;
  }

  // ── Enriquecimiento YGOPRODeck (cuando el producto no tiene metafields) ──
  var qvToken = 0;

  function ygoCacheGet(name) {
    try {
      var raw = sessionStorage.getItem('ygo:' + name.toLowerCase());
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function ygoCacheSet(name, val) {
    try { sessionStorage.setItem('ygo:' + name.toLowerCase(), JSON.stringify(val)); } catch (e) {}
  }

  function fetchCard(qs) {
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctrl && setTimeout(function () { ctrl.abort(); }, 3000);
    return fetch('/apps/tcg/ygo?' + qs, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) {
        if (timer) clearTimeout(timer);
        if (!r.ok) throw new Error('ygo http ' + r.status);
        return r.json();
      })
      .then(function (j) { return (j && j.data && j.data[0]) || null; });
  }

  function applyEnrich(s, d, token) {
    if (token !== qvToken || modal.hidden) return;
    renderStats({
      atk: d.atk || s.atk,
      def: d.def || s.def,
      attr: d.attr || s.attr,
      level: d.level || s.level,
      race: d.race || s.race,
      type: d.type || s.type,
      archetype: d.archetype || s.archetype
    });
    if (!d.desc && s.desc) {
      el.desc.textContent = s.desc;
      el.desc.style.display = '';
    }
  }

  function enrich(name, d, token) {
    var cached = ygoCacheGet(name);
    if (cached) { applyEnrich(cached, d, token); return; }
    fetchCard('name=' + encodeURIComponent(name))
      .catch(function () { return fetchCard('fname=' + encodeURIComponent(name)); })
      .then(function (c) {
        if (!c) return;
        var lvl = c.level || c.rank || c.linkval;
        var slim = {
          atk: typeof c.atk === 'number' ? String(c.atk) : '',
          def: typeof c.def === 'number' ? String(c.def) : '',
          attr: c.attribute || '',
          level: lvl ? String(lvl) : '',
          race: c.race || '',
          type: c.type || '',
          archetype: c.archetype || '',
          desc: c.desc || ''
        };
        ygoCacheSet(name, slim);
        applyEnrich(slim, d, token);
      })
      .catch(function () { /* sin red o sin match: la modal ya muestra lo esencial */ });
  }

  function open(btn) {
    var d = btn.dataset;
    lastFocus = btn;

    // Carta + rareza
    el.front.className = 'tcg-qv__face tcg-qv__front tcg-card' + (d.raritySlug && d.raritySlug !== 'none' ? ' tcg-rarity-' + d.raritySlug : '');
    el.front.setAttribute('data-rarity', d.raritySlug || 'none');
    if (el.flip) el.flip.classList.remove('is-flipped');
    el.img.src = d.img || '';
    el.img.alt = d.title || '';

    if (d.rarity) { el.badge.hidden = false; el.badge.textContent = d.rarity; el.badge.className = 'tcg-badge tcg-badge--' + (d.raritySlug || 'common'); }
    else { el.badge.hidden = true; }

    el.set.textContent = d.set || '';
    el.title.textContent = d.title || '';
    el.price.textContent = d.price || '';
    if (d.compare) { el.compare.hidden = false; el.compare.textContent = d.compare; } else { el.compare.hidden = true; }

    // Stats YGO
    renderStats(d);

    el.desc.textContent = d.desc || '';
    el.desc.style.display = d.desc ? '' : 'none';

    // Si el producto no tiene metafields, intenta completar desde YGOPRODeck
    qvToken++;
    if (!d.atk && !d.desc && d.title) enrich(d.title, d, qvToken);

    el.full.href = d.url || '#';

    // Add to cart
    el.add.className = 'tcg-qv__add';
    el.add.disabled = (d.available === 'false' || !d.variant);
    el.add.textContent = el.add.disabled ? 'Agotado' : 'Agregar al carrito';
    el.add.dataset.variant = d.variant || '';

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { modal.querySelector('.tcg-qv__close').focus(); });
  }

  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }

  // Tilt + glare en la carta grande
  function onMove(e) {
    if (reduceMotion || document.documentElement.classList.contains('tcg-fx-off')) return;
    var r = el.card.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width;
    var py = (e.clientY - r.top) / r.height;
    if (el.holo) { el.holo.style.setProperty('--mx', (px * 100).toFixed(1) + '%'); el.holo.style.setProperty('--my', (py * 100).toFixed(1) + '%'); el.holo.style.opacity = '1'; }
    el.card.style.transform = 'rotateX(' + ((0.5 - py) * 14).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 14).toFixed(2) + 'deg)';
  }
  function onLeave() { el.card.style.transform = ''; if (el.holo) el.holo.style.opacity = ''; }

  function addToCart() {
    var id = el.add.dataset.variant;
    if (!id || el.add.disabled) return;
    var original = el.add.textContent;
    el.add.disabled = true; el.add.textContent = 'Agregando…';
    tcgAddToCart({ id: Number(id) })
      .then(function () {
        el.add.classList.add('is-added'); el.add.textContent = '¡Añadido! ✓';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach(function (s) { s.textContent = cart.item_count; });
        }
        setTimeout(function () { el.add.disabled = false; el.add.classList.remove('is-added'); el.add.textContent = original; }, 1800);
      })
      .catch(function (err) {
        if (window.tcgCartToast) tcgCartToast(err && err.message);
        el.add.disabled = false; el.add.textContent = 'Reintentar';
      });
  }

  // Delegación: abrir desde cualquier botón [data-qv]
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-qv-flip]')) { if (el.flip) el.flip.classList.toggle('is-flipped'); return; }
    var btn = e.target.closest('[data-qv]');
    if (btn) { e.preventDefault(); open(btn); return; }
    if (e.target.closest('[data-qv-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  if (el.card) { el.card.addEventListener('pointermove', onMove); el.card.addEventListener('pointerleave', onLeave); }
  if (el.add) el.add.addEventListener('click', addToCart);
})();
